// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom"; // Often useful for dashboards
// import { FaUserCircle, FaUserCheck } from "react-icons/fa";
// import { MdSettings, MdPendingActions, MdAssignmentTurnedIn } from "react-icons/md";
// import { PiHandDepositBold, PiListNumbersFill } from "react-icons/pi";
// import { TbListNumbers } from "react-icons/tb";
// import { AiOutlineClose } from "react-icons/ai";
// import { IoMdClose, IoMdCloseCircleOutline } from "react-icons/io";
// import { RiCloseCircleLine, RiPassPendingFill } from "react-icons/ri";
// import { GiPodiumWinner } from "react-icons/gi";
// import { HiMiniCubeTransparent } from "react-icons/hi2";
// import { GoProjectRoadmap } from "react-icons/go";
// import { Container, Row, Col, Card, Modal, Button } from "react-bootstrap";
// import { LiaGiftSolid } from "react-icons/lia";

// const API_URL = process.env.REACT_APP_API_URL;

// // Map string names to actual React Icon components
// const iconMap = {
//   FaUserCircle: FaUserCircle,
//   PiHandDepositBold: PiHandDepositBold,
//   PiListNumbersFill: PiListNumbersFill,
//   TbListNumbers: TbListNumbers,
//   AiOutlineClose: AiOutlineClose,
//   IoMdClose: IoMdClose,
//   MdPendingActions: MdPendingActions,
//   IoMdCloseCircleOutline: IoMdCloseCircleOutline,
//   RiCloseCircleLine: RiCloseCircleLine,
//   RiPassPendingFill: RiPassPendingFill,
//   GiPodiumWinner: GiPodiumWinner,
//   HiMiniCubeTransparent: HiMiniCubeTransparent,
//   FaUserCheck: FaUserCheck,
//   MdSettings: MdSettings,
//   MdAssignmentTurnedIn: MdAssignmentTurnedIn,
//   GoProjectRoadmap: GoProjectRoadmap,
//   LiaGiftSolid
// };

// const Dashboard = () => {
//   const [dashboardData, setDashboardData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   // States for custom message modal (reused from previous components)
//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });

//   // Custom modal for messages
//   const showCustomMessageModal = (title, text, type, confirmAction = null) => {
//     setMessageModalContent({ title, text, type, confirmAction });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//     setMessageModalContent({ title: "", text: "", type: "", confirmAction: null });
//   };

//   // Helper function to get the authentication token from localStorage
//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   useEffect(() => {
//     const fetchDashboardData = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const token = getAuthToken();
//         if (!token) {
//           showCustomMessageModal("Authentication Error", "Authentication token not found. Please log in.", "error");
//           // Optionally redirect to login page
//           // navigate('/login');
//           return;
//         }

//         const response = await fetch(`${API_URL}/dashboard-list`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (!response.ok) {
//           if (response.status === 401) {
//             showCustomMessageModal("Authorization Error", "Unauthorized: Please log in again.", "error");
//             // Optionally redirect to login page
//             // navigate('/login');
//           } else {
//             const errorData = await response.json();
//             showCustomMessageModal("Error", errorData.message || "Failed to fetch dashboard data.", "error");
//           }
//           throw new Error(response.statusText);
//         }

//         const rawData = await response.json();


//         const transformedData = [
//           { title: "Today Associates", value: rawData.todayAssociate?.[0]?.total || 0, icon: "FaUserCircle", color: "primary", link: "/today-associate-list" },
//           { title: "Today Channels Partner", value: rawData.todayChannel?.[0]?.total || 0, icon: "FaUserCheck", color: "info", link:"/today-channel-list" },
//           // { title: "Today Users", value: rawData.todayuser?.[0]?.total || 0, icon: "MdSettings", color: "success" },
//           // { title: "Today Projects", value: rawData.todayProject?.[0]?.total || 0, icon: "MdAssignmentTurnedIn", color: "warning", link:"/all-project" },
//           // { title: "Today Blocks", value: rawData.todayblock?.[0]?.total || 0, icon: "HiMiniCubeTransparent", color: "danger", link:"/all-block-list" },
//           // { title: "Today Plots", value: rawData.todayPlot?.[0]?.total || 0, icon: "PiListNumbersFill", color: "secondary", link:"/all-plot" },

//           { title: "Total Associates", value: rawData.AllAssociate?.[0]?.total || 0, icon: "FaUserCircle", color: "primary", link: "/all-associate-list" },
//           { title: "Active Associates", value: rawData.ActiveAssociate?.[0]?.total || 0, icon: "FaUserCheck", color: "success", link:"/all-associate-active-list" },
//           { title: "Inactive Associates", value: rawData.InactiveAssociate?.[0]?.total || 0, icon: "RiCloseCircleLine", color: "danger", link:"/all-associate-inactive-list" },

//           { title: "Total Channels Partner", value: rawData.AllChannel?.[0]?.total || 0, icon: "FaUserCheck", color: "info", link:"/all-channel-list" },
//           { title: "Active Channels Partner", value: rawData.ActiveChannel?.[0]?.total || 0, icon: "FaUserCheck", color: "success", link:"/all-channel-active-list" },
//           { title: "Inactive Channels Partner", value: rawData.InactiveChannel?.[0]?.total || 0, icon: "RiCloseCircleLine", color: "danger", link:"/all-channel-inactive-list" },

//           // { title: "Total Users", value: rawData.Alluser?.[0]?.total || 0, icon: "MdSettings", color: "primary" },
//           // { title: "Active Users", value: rawData.Activeuser?.[0]?.total || 0, icon: "MdSettings", color: "success" },
//           // { title: "Inactive Users", value: rawData.Inactiveuser?.[0]?.total || 0, icon: "RiCloseCircleLine", color: "danger" },

//           { title: "Total Projects", value: rawData.AllProject?.[0]?.total || 0, icon: "MdAssignmentTurnedIn", color: "primary", link:"/all-project" },
//           // { title: "Active Projects", value: rawData.ActiveProject?.[0]?.total || 0, icon: "MdAssignmentTurnedIn", color: "success", link:"/active-project" },
//           // { title: "Inactive Projects", value: rawData.InactiveProject?.[0]?.total || 0, icon: "RiCloseCircleLine", color: "danger", link:"/inactive-project" },

//           // { title: "Total Blocks", value: rawData.Allblock?.[0]?.total || 0, icon: "HiMiniCubeTransparent", color: "primary", link:"/all-block-list" },
//           // { title: "Active Blocks", value: rawData.Activeblock?.[0]?.total || 0, icon: "HiMiniCubeTransparent", color: "success", link:"/active-block-list" },
//           // { title: "Inactive Blocks", value: rawData.Inactivblock?.[0]?.total || 0, icon: "RiCloseCircleLine", color: "danger", link:"/inactive-block-list" },

//           { title: "Total Plots", value: rawData.AllPlot?.[0]?.total || 0, icon: "PiListNumbersFill", color: "primary", link:"/all-plot" },
//           { title: "Available Plots", value: rawData.ActivePlot?.[0]?.total || 0, icon: "PiListNumbersFill", color: "success", link:"/active-plot-list" },
//           { title: "Sold Plots", value: rawData.InactivePlot?.[0]?.total || 0, icon: "RiCloseCircleLine", color: "danger", link:"/inactive-plot-list" },
//           { title: "Total Property Lead", value: rawData.TotalPropertyLead?.[0]?.total || 0, icon: "GoProjectRoadmap", color: "primary", link:"/lead-list"},
//           { title: "Today Property Lead", value: rawData.TodayPropertyLead?.[0]?.total || 0, icon: "GoProjectRoadmap", color: "primary"},
//           { title: "Total Loan Lead", value: rawData.TotalLoanLead?.[0]?.total || 0, icon: "PiListNumbersFill", color: "primary"},
//           { title: "Today Loan Lead", value: rawData.TodayLoanLead?.[0]?.total || 0, icon: "PiListNumbersFill", color: "primary"},

//           { title: "Total Bonus Achiever", value: rawData.totalBonusCount?.[0]?.total || 0, icon: "LiaGiftSolid", color: "primary",  link:"/associates-bonus-reward-list"},

//            { title: "Total Bima Achiever", value: rawData.totalBimaCount?.[0]?.total || 0, icon: "LiaGiftSolid", color: "primary",  link:"/associates-bima-achiever-lists"},


//         ];

//         setDashboardData(transformedData);
//       } catch (err) {
//         console.error("Fetch dashboard data error:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDashboardData();
//   }, []);

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
//         <div className="spinner-border text-primary" role="status">
//           <span className="sr-only">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return null;
//   }

//   return (
//     <div className="padding_15">
//       <div className="dashboard">
//       <Row className="g-4">
//           {dashboardData.length > 0 ? (
//             dashboardData.map((item, index) => {
//               const IconComponent = iconMap[item.icon];
              
//               return (
//                 <div key={item.id || index} className="col-xs-12 col-sm-6 col-md-4 col-lg-3">
//                   {/* Make the entire card clickable */}
//                   <div 
//                     className={`card bg_card_design clickable-card`} 
//                     onClick={() => item.link && navigate(item.link)}
//                     style={{ cursor: item.link ? 'pointer' : 'default' }}
//                   >
//                     <div className="card-body gap-2 d-flex align-items-center justify-content-start">
//                       {IconComponent && (
//                         <div className="icon_dashboard">
//                           <IconComponent size={50} className="text-white" />
//                         </div>
//                       )}
//                       <div>
//                         <div className="card-title text-dark">{item.title}</div>
//                         <div className="card-text">
//                           {item.value}
//                         </div>
                        
                       
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })
//           ) : (
//             <Col xs={12}>
//               <div className="text-center text-muted mt-5">
//                 No dashboard data available.
//               </div>
//             </Col>
//           )}
//         </Row>

//       {/* Custom Message Modal */}
//       {showMessageModal && (
//         <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
//           <div className="modal-dialog modal-dialog-centered">
//             <div className={`modal-content ${messageModalContent.type === 'success' ? 'border-success' : messageModalContent.type === 'error' ? '' : ''}`}>
//               <div className="modal-header d-flex justify-content-between align-items-center">
//                 <h5 className={`modal-title ${messageModalContent.type === 'success' ? 'text-success' : messageModalContent.type === 'error' ? 'text-danger' : 'text-warning'}`}>
//                   {messageModalContent.title}
//                 </h5>
//                 <button type="button" className="btn-close" aria-label="Close" onClick={closeCustomMessageModal}></button>
//               </div>
//               <div className="modal-body text-secondary">
//                 <p>{messageModalContent.text}</p>
//               </div>
//               <div className="modal-footer justify-content-center">
//                 {messageModalContent.confirmAction ? (
//                   <>
//                     <Button
//                       variant="secondary"
//                       onClick={closeCustomMessageModal}
//                     >
//                       Cancel
//                     </Button>
//                     <Button
//                       variant={messageModalContent.type === 'warning' ? 'warning' : 'primary'}
//                       onClick={() => {
//                         messageModalContent.confirmAction();
//                         closeCustomMessageModal();
//                       }}
//                     >
//                       Confirm
//                     </Button>
//                   </>
//                 ) : (
//                   <Button
//                     variant={messageModalContent.type === 'success' ? 'success' : messageModalContent.type === 'error' ? 'danger' : 'primary'}
//                     onClick={closeCustomMessageModal}
//                   >
//                     OK
//                   </Button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//     </div>
//   );
// };

// export default Dashboard;

// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaUserCircle, FaUserCheck } from "react-icons/fa";
// import {
//   MdSettings,
//   MdPendingActions,
//   MdAssignmentTurnedIn,
// } from "react-icons/md";
// import { PiHandDepositBold, PiListNumbersFill } from "react-icons/pi";
// import { TbListNumbers } from "react-icons/tb";
// import { AiOutlineClose } from "react-icons/ai";
// import { IoMdClose, IoMdCloseCircleOutline } from "react-icons/io";
// import { RiCloseCircleLine, RiPassPendingFill } from "react-icons/ri";
// import { GiPodiumWinner } from "react-icons/gi";
// import { HiMiniCubeTransparent } from "react-icons/hi2";
// import { GoProjectRoadmap } from "react-icons/go";
// import { Container, Row, Col, Card, Modal, Button } from "react-bootstrap";
// import { LiaGiftSolid } from "react-icons/lia";

// const API_URL = process.env.REACT_APP_API_URL;

// const iconMap = {
//   FaUserCircle,
//   PiHandDepositBold,
//   PiListNumbersFill,
//   TbListNumbers,
//   AiOutlineClose,
//   IoMdClose,
//   MdPendingActions,
//   IoMdCloseCircleOutline,
//   RiCloseCircleLine,
//   RiPassPendingFill,
//   GiPodiumWinner,
//   HiMiniCubeTransparent,
//   FaUserCheck,
//   MdSettings,
//   MdAssignmentTurnedIn,
//   GoProjectRoadmap,
//   LiaGiftSolid,
// };

// // 🎨 Gradient themes per color key
// const colorThemes = {
//   primary: {
//     bg: "linear-gradient(135deg, #1e5799 0%, #2b6cb0 100%)",
//     glow: "rgba(30, 87, 153, 0.35)",
//     badge: "#e0ecff",
//     badgeText: "#1e5799",
//     ring: "#2b6cb0",
//   },
//   success: {
//     bg: "linear-gradient(135deg, #16a34a 0%, #22c55e 100%)",
//     glow: "rgba(22, 163, 74, 0.35)",
//     badge: "#dcfce7",
//     badgeText: "#16a34a",
//     ring: "#22c55e",
//   },
//   danger: {
//     bg: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
//     glow: "rgba(220, 38, 38, 0.35)",
//     badge: "#fee2e2",
//     badgeText: "#dc2626",
//     ring: "#ef4444",
//   },
//   info: {
//     bg: "linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)",
//     glow: "rgba(8, 145, 178, 0.35)",
//     badge: "#cffafe",
//     badgeText: "#0891b2",
//     ring: "#06b6d4",
//   },
//   warning: {
//     bg: "linear-gradient(135deg, #d97706 0%, #f59e0b 100%)",
//     glow: "rgba(217, 119, 6, 0.35)",
//     badge: "#fef3c7",
//     badgeText: "#d97706",
//     ring: "#f59e0b",
//   },
//   secondary: {
//     bg: "linear-gradient(135deg, #475569 0%, #64748b 100%)",
//     glow: "rgba(71, 85, 105, 0.35)",
//     badge: "#e2e8f0",
//     badgeText: "#475569",
//     ring: "#64748b",
//   },
// };

// const Dashboard = () => {
//   const [dashboardData, setDashboardData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });

//   const showCustomMessageModal = (title, text, type, confirmAction = null) => {
//     setMessageModalContent({ title, text, type, confirmAction });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//     setMessageModalContent({
//       title: "",
//       text: "",
//       type: "",
//       confirmAction: null,
//     });
//   };

//   const getAuthToken = () => localStorage.getItem("token");

//   useEffect(() => {
//     const fetchDashboardData = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const token = getAuthToken();
//         if (!token) {
//           showCustomMessageModal(
//             "Authentication Error",
//             "Authentication token not found. Please log in.",
//             "error",
//           );
//           return;
//         }

//         const response = await fetch(`${API_URL}/dashboard-list`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (!response.ok) {
//           if (response.status === 401) {
//             showCustomMessageModal(
//               "Authorization Error",
//               "Unauthorized: Please log in again.",
//               "error",
//             );
//           } else {
//             const errorData = await response.json();
//             showCustomMessageModal(
//               "Error",
//               errorData.message || "Failed to fetch dashboard data.",
//               "error",
//             );
//           }
//           throw new Error(response.statusText);
//         }

//         const rawData = await response.json();

//         const transformedData = [
//           {
//             title: "Today Associates",
//             value: rawData.todayAssociate?.[0]?.total || 0,
//             icon: "FaUserCircle",
//             color: "primary",
//             link: "/today-associate-list",
//           },
//           // {
//           //   title: "Today Channels Partner",
//           //   value: rawData.todayChannel?.[0]?.total || 0,
//           //   icon: "FaUserCheck",
//           //   color: "info",
//           //   link: "/today-channel-list",
//           // },
//           {
//             title: "Total Associates",
//             value: rawData.AllAssociate?.[0]?.total || 0,
//             icon: "FaUserCircle",
//             color: "primary",
//             link: "/all-associate-list",
//           },
//           {
//             title: "Active Associates",
//             value: rawData.ActiveAssociate?.[0]?.total || 0,
//             icon: "FaUserCheck",
//             color: "success",
//             link: "/all-associate-active-list",
//           },
//           {
//             title: "Inactive Associates",
//             value: rawData.InactiveAssociate?.[0]?.total || 0,
//             icon: "RiCloseCircleLine",
//             color: "danger",
//             link: "/all-associate-inactive-list",
//           },
//           // {
//           //   title: "Total Channels Partner",
//           //   value: rawData.AllChannel?.[0]?.total || 0,
//           //   icon: "FaUserCheck",
//           //   color: "info",
//           //   link: "/all-channel-list",
//           // },
//           // {
//           //   title: "Active Channels Partner",
//           //   value: rawData.ActiveChannel?.[0]?.total || 0,
//           //   icon: "FaUserCheck",
//           //   color: "success",
//           //   link: "/all-channel-active-list",
//           // },
//           // {
//           //   title: "Inactive Channels Partner",
//           //   value: rawData.InactiveChannel?.[0]?.total || 0,
//           //   icon: "RiCloseCircleLine",
//           //   color: "danger",
//           //   link: "/all-channel-inactive-list",
//           // },
//           {
//             title: "Total Projects",
//             value: rawData.AllProject?.[0]?.total || 0,
//             icon: "MdAssignmentTurnedIn",
//             color: "primary",
//             link: "/all-project",
//           },
//           {
//             title: "Total Plots",
//             value: rawData.AllPlot?.[0]?.total || 0,
//             icon: "PiListNumbersFill",
//             color: "primary",
//             link: "/all-plot",
//           },
//           {
//             title: "Available Plots",
//             value: rawData.ActivePlot?.[0]?.total || 0,
//             icon: "PiListNumbersFill",
//             color: "success",
//             link: "/active-plot-list",
//           },
//           {
//             title: "Sold Plots",
//             value: rawData.InactivePlot?.[0]?.total || 0,
//             icon: "RiCloseCircleLine",
//             color: "danger",
//             link: "/inactive-plot-list",
//           },
//           {
//             title: "Total Property Lead",
//             value: rawData.TotalPropertyLead?.[0]?.total || 0,
//             icon: "GoProjectRoadmap",
//             color: "primary",
//             link: "/lead-list",
//           },
//           {
//             title: "Today Property Lead",
//             value: rawData.TodayPropertyLead?.[0]?.total || 0,
//             icon: "GoProjectRoadmap",
//             color: "warning",
//           },
//           // {
//           //   title: "Total Loan Lead",
//           //   value: rawData.TotalLoanLead?.[0]?.total || 0,
//           //   icon: "PiListNumbersFill",
//           //   color: "primary",
//           // },
//           // {
//           //   title: "Today Loan Lead",
//           //   value: rawData.TodayLoanLead?.[0]?.total || 0,
//           //   icon: "PiListNumbersFill",
//           //   color: "warning",
//           // },
//           {
//             title: "Total Bonus Achiever",
//             value: rawData.totalBonusCount?.[0]?.total || 0,
//             icon: "LiaGiftSolid",
//             color: "primary",
//             link: "/associates-bonus-reward-list",
//           },
//           {
//             title: "Total Bima Achiever",
//             value: rawData.totalBimaCount?.[0]?.total || 0,
//             icon: "LiaGiftSolid",
//             color: "primary",
//             link: "/associates-bima-achiever-lists",
//           },
//         ];

//         setDashboardData(transformedData);
//       } catch (err) {
//         console.error("Fetch dashboard data error:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDashboardData();
//   }, []);

//   if (loading) {
//     return (
//       <div
//         style={{
//           minHeight: "80vh",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//         }}
//       >
//         <div style={{ textAlign: "center", color: "#64748b" }}>
//           <div
//             style={{
//               width: "48px",
//               height: "48px",
//               border: "4px solid #cbd5e1",
//               borderTop: "4px solid #2b6cb0",
//               borderRadius: "50%",
//               display: "inline-block",
//               animation: "spin 0.8s linear infinite",
//             }}
//           />
//           <p style={{ marginTop: "16px", fontWeight: 600 }}>
//             Loading Dashboard...
//           </p>
//         </div>
//         <style>{`
//           @keyframes spin {
//             from { transform: rotate(0deg); }
//             to { transform: rotate(360deg); }
//           }
//         `}</style>
//       </div>
//     );
//   }

//   if (error) return null;

//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1600px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//               }}
//             >
//               📊
//             </div>
//             <div style={{ flex: 1, minWidth: "220px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "22px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Dashboard Overview
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Real-time statistics and analytics
//               </p>
//             </div>
//           </div>

//           {/* 🎯 STAT CARDS */}
//           <Row className="g-3">
//             {dashboardData.length > 0 ? (
//               dashboardData.map((item, index) => {
//                 const IconComponent = iconMap[item.icon];
//                 const theme = colorThemes[item.color] || colorThemes.primary;

//                 return (
//                   <Col
//                     key={index}
//                     xs={12}
//                     sm={6}
//                     md={4}
//                     lg={3}
//                     className="mb-2"
//                   >
//                     <div
//                       onClick={() => item.link && navigate(item.link)}
//                       className="stat-card"
//                       style={{
//                         background: "#ffffff",
//                         borderRadius: "16px",
//                         padding: "18px 20px",
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "16px",
//                         cursor: item.link ? "pointer" : "default",
//                         position: "relative",
//                         overflow: "hidden",
//                         border: "1.5px solid #e2e8f0",
//                         boxShadow: "0 4px 14px rgba(30, 87, 153, 0.06)",
//                         transition:
//                           "transform 0.3s ease, box-shadow 0.3s ease",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.currentTarget.style.transform =
//                           "translateY(-4px) scale(1.02)";
//                         e.currentTarget.style.boxShadow = `0 14px 30px ${theme.glow}`;
//                         e.currentTarget.style.borderColor = theme.ring;
//                       }}
//                       onMouseLeave={(e) => {
//                         e.currentTarget.style.transform =
//                           "translateY(0) scale(1)";
//                         e.currentTarget.style.boxShadow =
//                           "0 4px 14px rgba(30, 87, 153, 0.06)";
//                         e.currentTarget.style.borderColor = "#e2e8f0";
//                       }}
//                     >
//                       {/* Subtle background blob */}
//                       <div
//                         style={{
//                           position: "absolute",
//                           right: "-30px",
//                           bottom: "-30px",
//                           width: "110px",
//                           height: "110px",
//                           borderRadius: "50%",
//                           background: theme.bg,
//                           opacity: 0.06,
//                           pointerEvents: "none",
//                         }}
//                       />

//                       {/* Icon badge with gradient + glow */}
//                       {IconComponent && (
//                         <div
//                           style={{
//                             width: "52px",
//                             height: "52px",
//                             borderRadius: "14px",
//                             background: theme.bg,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             color: "#ffffff",
//                             flexShrink: 0,
//                             boxShadow: `0 8px 18px ${theme.glow}`,
//                           }}
//                         >
//                           <IconComponent size={26} />
//                         </div>
//                       )}

//                       {/* Text */}
//                       <div style={{ flex: 1, minWidth: 0 }}>
//                         <div
//                           style={{
//                             fontSize: "12.5px",
//                             fontWeight: "600",
//                             color: "#64748b",
//                             lineHeight: "1.3",
//                             marginBottom: "4px",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                           }}
//                           title={item.title}
//                         >
//                           {item.title}
//                         </div>
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "baseline",
//                             gap: "8px",
//                           }}
//                         >
//                           <span
//                             style={{
//                               fontSize: "24px",
//                               fontWeight: "800",
//                               color: "#1e3a5f",
//                               letterSpacing: "-0.5px",
//                               lineHeight: 1,
//                             }}
//                           >
//                             {item.value}
//                           </span>
//                           <span
//                             style={{
//                               fontSize: "10px",
//                               fontWeight: "700",
//                               padding: "2px 8px",
//                               borderRadius: "20px",
//                               background: theme.badge,
//                               color: theme.badgeText,
//                               letterSpacing: "0.3px",
//                             }}
//                           >
//                             {item.link ? "VIEW →" : "TOTAL"}
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </Col>
//                 );
//               })
//             ) : (
//               <Col xs={12}>
//                 <div className="text-center text-muted mt-5">
//                   No dashboard data available.
//                 </div>
//               </Col>
//             )}
//           </Row>
//         </div>
//       </div>

//       {/* Custom Message Modal */}
//       {showMessageModal && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div
//               className={`modal-content ${
//                 messageModalContent.type === "success" ? "border-success" : ""
//               }`}
//             >
//               <div className="modal-header d-flex justify-content-between align-items-center">
//                 <h5
//                   className={`modal-title ${
//                     messageModalContent.type === "success"
//                       ? "text-success"
//                       : messageModalContent.type === "error"
//                         ? "text-danger"
//                         : "text-warning"
//                   }`}
//                 >
//                   {messageModalContent.title}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   aria-label="Close"
//                   onClick={closeCustomMessageModal}
//                 ></button>
//               </div>
//               <div className="modal-body text-secondary">
//                 <p>{messageModalContent.text}</p>
//               </div>
//               <div className="modal-footer justify-content-center">
//                 {messageModalContent.confirmAction ? (
//                   <>
//                     <Button
//                       variant="secondary"
//                       onClick={closeCustomMessageModal}
//                     >
//                       Cancel
//                     </Button>
//                     <Button
//                       variant={
//                         messageModalContent.type === "warning"
//                           ? "warning"
//                           : "primary"
//                       }
//                       onClick={() => {
//                         messageModalContent.confirmAction();
//                         closeCustomMessageModal();
//                       }}
//                     >
//                       Confirm
//                     </Button>
//                   </>
//                 ) : (
//                   <Button
//                     variant={
//                       messageModalContent.type === "success"
//                         ? "success"
//                         : messageModalContent.type === "error"
//                           ? "danger"
//                           : "primary"
//                     }
//                     onClick={closeCustomMessageModal}
//                   >
//                     OK
//                   </Button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <style>{`
//         @keyframes spin {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//       `}</style>
//     </>
//   );
// };

// export default Dashboard;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUserCircle, FaUserCheck } from "react-icons/fa";
import {
  MdSettings,
  MdPendingActions,
  MdAssignmentTurnedIn,
} from "react-icons/md";
import { PiHandDepositBold, PiListNumbersFill } from "react-icons/pi";
import { TbListNumbers } from "react-icons/tb";
import { AiOutlineClose } from "react-icons/ai";
import { IoMdClose, IoMdCloseCircleOutline } from "react-icons/io";
import { RiCloseCircleLine, RiPassPendingFill } from "react-icons/ri";
import { GiPodiumWinner } from "react-icons/gi";
import { HiMiniCubeTransparent } from "react-icons/hi2";
import { GoProjectRoadmap } from "react-icons/go";
import { Container, Row, Col, Card, Modal, Button } from "react-bootstrap";
import { LiaGiftSolid } from "react-icons/lia";

const API_URL = process.env.REACT_APP_API_URL;

const iconMap = {
  FaUserCircle,
  PiHandDepositBold,
  PiListNumbersFill,
  TbListNumbers,
  AiOutlineClose,
  IoMdClose,
  MdPendingActions,
  IoMdCloseCircleOutline,
  RiCloseCircleLine,
  RiPassPendingFill,
  GiPodiumWinner,
  HiMiniCubeTransparent,
  FaUserCheck,
  MdSettings,
  MdAssignmentTurnedIn,
  GoProjectRoadmap,
  LiaGiftSolid,
};

// 🎨 Gradient themes per color key
const colorThemes = {
  primary: {
    bg: "linear-gradient(135deg, #1e5799 0%, #2b6cb0 100%)",
    glow: "rgba(30, 87, 153, 0.35)",
    badge: "#e0ecff",
    badgeText: "#1e5799",
    ring: "#2b6cb0",
  },
  success: {
    bg: "linear-gradient(135deg, #16a34a 0%, #22c55e 100%)",
    glow: "rgba(22, 163, 74, 0.35)",
    badge: "#dcfce7",
    badgeText: "#16a34a",
    ring: "#22c55e",
  },
  danger: {
    bg: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
    glow: "rgba(220, 38, 38, 0.35)",
    badge: "#fee2e2",
    badgeText: "#dc2626",
    ring: "#ef4444",
  },
  info: {
    bg: "linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)",
    glow: "rgba(8, 145, 178, 0.35)",
    badge: "#cffafe",
    badgeText: "#0891b2",
    ring: "#06b6d4",
  },
  warning: {
    bg: "linear-gradient(135deg, #d97706 0%, #f59e0b 100%)",
    glow: "rgba(217, 119, 6, 0.35)",
    badge: "#fef3c7",
    badgeText: "#d97706",
    ring: "#f59e0b",
  },
  secondary: {
    bg: "linear-gradient(135deg, #475569 0%, #64748b 100%)",
    glow: "rgba(71, 85, 105, 0.35)",
    badge: "#e2e8f0",
    badgeText: "#475569",
    ring: "#64748b",
  },
};

// 🍩 Pure SVG Donut Chart
const DonutChart = ({ segments, size = 180, thickness = 28 }) => {
  const total = segments.reduce((sum, s) => sum + s.value, 0) || 1;
  const radius = (size - thickness) / 2;
  const circumference = 2 * Math.PI * radius;
  let offset = 0;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="#e2e8f0"
        strokeWidth={thickness}
      />
      {segments.map((seg, idx) => {
        const length = (seg.value / total) * circumference;
        const dash = `${length} ${circumference - length}`;
        const rotate = (offset / total) * 360 - 90;
        offset += seg.value;
        return (
          <circle
            key={idx}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={seg.color}
            strokeWidth={thickness}
            strokeDasharray={dash}
            strokeLinecap="butt"
            transform={`rotate(${rotate} ${size / 2} ${size / 2})`}
            style={{ transition: "stroke-dasharray 1s ease" }}
          />
        );
      })}
    </svg>
  );
};

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState([]);
  const [rawDashboardData, setRawDashboardData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
    confirmAction: null,
  });

  const showCustomMessageModal = (title, text, type, confirmAction = null) => {
    setMessageModalContent({ title, text, type, confirmAction });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = () => {
    setShowMessageModal(false);
    setMessageModalContent({
      title: "",
      text: "",
      type: "",
      confirmAction: null,
    });
  };

  const getAuthToken = () => localStorage.getItem("token");

  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = getAuthToken();
        if (!token) {
          showCustomMessageModal(
            "Authentication Error",
            "Authentication token not found. Please log in.",
            "error",
          );
          return;
        }

        const response = await fetch(`${API_URL}/dashboard-list`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          if (response.status === 401) {
            showCustomMessageModal(
              "Authorization Error",
              "Unauthorized: Please log in again.",
              "error",
            );
          } else {
            const errorData = await response.json();
            showCustomMessageModal(
              "Error",
              errorData.message || "Failed to fetch dashboard data.",
              "error",
            );
          }
          throw new Error(response.statusText);
        }

        const rawData = await response.json();
        setRawDashboardData(rawData);

        const transformedData = [
          {
            title: "Today Associates",
            value: rawData.todayAssociate?.[0]?.total || 0,
            icon: "FaUserCircle",
            color: "primary",
            link: "/today-associate-list",
          },
          {
            title: "Total Associates",
            value: rawData.AllAssociate?.[0]?.total || 0,
            icon: "FaUserCircle",
            color: "primary",
            link: "/all-associate-list",
          },
          {
            title: "Active Associates",
            value: rawData.ActiveAssociate?.[0]?.total || 0,
            icon: "FaUserCheck",
            color: "success",
            link: "/all-associate-active-list",
          },
          {
            title: "Inactive Associates",
            value: rawData.InactiveAssociate?.[0]?.total || 0,
            icon: "RiCloseCircleLine",
            color: "danger",
            link: "/all-associate-inactive-list",
          },
          {
            title: "Total Projects",
            value: rawData.AllProject?.[0]?.total || 0,
            icon: "MdAssignmentTurnedIn",
            color: "primary",
            link: "/all-project",
          },
          {
            title: "Total Plots",
            value: rawData.AllPlot?.[0]?.total || 0,
            icon: "PiListNumbersFill",
            color: "primary",
            link: "/all-plot",
          },
          {
            title: "Available Plots",
            value: rawData.ActivePlot?.[0]?.total || 0,
            icon: "PiListNumbersFill",
            color: "success",
            link: "/active-plot-list",
          },
          {
            title: "Sold Plots",
            value: rawData.InactivePlot?.[0]?.total || 0,
            icon: "RiCloseCircleLine",
            color: "danger",
            link: "/inactive-plot-list",
          },
          {
            title: "Total Property Lead",
            value: rawData.TotalPropertyLead?.[0]?.total || 0,
            icon: "GoProjectRoadmap",
            color: "primary",
            link: "/lead-list",
          },
          {
            title: "Today Property Lead",
            value: rawData.TodayPropertyLead?.[0]?.total || 0,
            icon: "GoProjectRoadmap",
            color: "warning",
          },
          {
            title: "Total Bonus Achiever",
            value: rawData.totalBonusCount?.[0]?.total || 0,
            icon: "LiaGiftSolid",
            color: "primary",
            link: "/associates-bonus-reward-list",
          },
          {
            title: "Total Bima Achiever",
            value: rawData.totalBimaCount?.[0]?.total || 0,
            icon: "LiaGiftSolid",
            color: "primary",
            link: "/associates-bima-achiever-lists",
          },
        ];

        setDashboardData(transformedData);
      } catch (err) {
        console.error("Fetch dashboard data error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  // 🎯 Derived data
  const totalAssociates = rawDashboardData.AllAssociate?.[0]?.total || 0;
  const activeAssociates = rawDashboardData.ActiveAssociate?.[0]?.total || 0;
  const inactiveAssociates = rawDashboardData.InactiveAssociate?.[0]?.total || 0;

  const totalPlots = rawDashboardData.AllPlot?.[0]?.total || 0;
  const availablePlots = rawDashboardData.ActivePlot?.[0]?.total || 0;
  const soldPlots = rawDashboardData.InactivePlot?.[0]?.total || 0;

  const totalProjects = rawDashboardData.AllProject?.[0]?.total || 0;
  const totalPropertyLead = rawDashboardData.TotalPropertyLead?.[0]?.total || 0;
  const todayPropertyLead = rawDashboardData.TodayPropertyLead?.[0]?.total || 0;

  const totalBonus = rawDashboardData.totalBonusCount?.[0]?.total || 0;
  const totalBima = rawDashboardData.totalBimaCount?.[0]?.total || 0;

  // 📊 Progress Overview items
  const maxProgress = Math.max(
    totalAssociates,
    totalPlots,
    totalProjects,
    totalPropertyLead,
    1,
  );

  const progressItems = [
    {
      label: "Total Associates",
      value: totalAssociates,
      emoji: "👥",
      color: "linear-gradient(90deg, #2b6cb0, #4a90e2)",
      badge: "#e0ecff",
      badgeText: "#1e5799",
      glow: "rgba(43,108,176,0.5)",
    },
    {
      label: "Total Plots",
      value: totalPlots,
      emoji: "🏠",
      color: "linear-gradient(90deg, #0891b2, #06b6d4)",
      badge: "#cffafe",
      badgeText: "#0891b2",
      glow: "rgba(6,182,212,0.5)",
    },
    {
      label: "Active Associates",
      value: activeAssociates,
      emoji: "✅",
      color: "linear-gradient(90deg, #16a34a, #22c55e)",
      badge: "#dcfce7",
      badgeText: "#16a34a",
      glow: "rgba(34,197,94,0.5)",
    },
    {
      label: "Total Projects",
      value: totalProjects,
      emoji: "📋",
      color: "linear-gradient(90deg, #7c3aed, #a78bfa)",
      badge: "#ede9fe",
      badgeText: "#7c3aed",
      glow: "rgba(139,92,246,0.5)",
    },
    {
      label: "Available Plots",
      value: availablePlots,
      emoji: "🏘️",
      color: "linear-gradient(90deg, #d97706, #f59e0b)",
      badge: "#fef3c7",
      badgeText: "#d97706",
      glow: "rgba(245,158,11,0.5)",
    },
    {
      label: "Total Bonus Achievers",
      value: totalBonus,
      emoji: "🎁",
      color: "linear-gradient(90deg, #dc2626, #ef4444)",
      badge: "#fee2e2",
      badgeText: "#dc2626",
      glow: "rgba(239,68,68,0.5)",
    },
  ];

  // 📊 Revenue trend bars
  const revenueBars = [
    { label: "Assoc", value: totalAssociates },
    { label: "Active", value: activeAssociates },
    { label: "Plots", value: totalPlots },
    { label: "Avail", value: availablePlots },
    { label: "Sold", value: soldPlots },
    { label: "Lead", value: totalPropertyLead },
  ];
  const maxRevenue = Math.max(...revenueBars.map((b) => b.value), 1);

  // 📊 Donut segments
  const donutSegments = [
    {
      label: "Active Assoc.",
      value: activeAssociates,
      color: "#16a34a",
    },
    {
      label: "Inactive Assoc.",
      value: inactiveAssociates,
      color: "#1e5799",
    },
    {
      label: "Today Lead",
      value: todayPropertyLead,
      color: "#8b5cf6",
    },
  ];
  const donutTotal = donutSegments.reduce((s, x) => s + x.value, 0) || 1;

  // 📊 Recent Activity
  const recentActivities = [
    {
      icon: "👤",
      color: "#e0ecff",
      text: `Total ${totalAssociates} Associates registered`,
      badge: "All",
    },
    {
      icon: "✅",
      color: "#dcfce7",
      text: `${activeAssociates} Active Associates`,
      badge: "Active",
    },
    {
      icon: "🏠",
      color: "#cffafe",
      text: `${totalPlots} Total Plots across projects`,
      badge: "Plots",
    },
    {
      icon: "📋",
      color: "#fef3c7",
      text: `${totalPropertyLead} Property Leads received`,
      badge: "Leads",
    },
    {
      icon: "🎁",
      color: "#ede9fe",
      text: `${totalBonus + totalBima} Total Achievers rewarded`,
      badge: "Rewards",
    },
  ];

  if (loading) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div style={{ textAlign: "center", color: "#64748b" }}>
          <div
            style={{
              width: "48px",
              height: "48px",
              border: "4px solid #cbd5e1",
              borderTop: "4px solid #2b6cb0",
              borderRadius: "50%",
              display: "inline-block",
              animation: "spin 0.8s linear infinite",
            }}
          />
          <p style={{ marginTop: "16px", fontWeight: 600 }}>
            Loading Dashboard...
          </p>
        </div>
        <style>{`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (error) return null;

  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1600px", margin: "0 auto" }}>
          {/* 🎯 HEADER CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              padding: "20px 24px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "24px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
              }}
            >
              📊
            </div>
            <div style={{ flex: 1, minWidth: "220px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "22px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Dashboard Overview
              </h1>
              <p
                style={{
                  margin: "2px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                Real-time statistics and analytics
              </p>
            </div>
          </div>

          {/* 🎯 STAT CARDS */}
          <Row className="g-3">
            {dashboardData.length > 0 ? (
              dashboardData.map((item, index) => {
                const IconComponent = iconMap[item.icon];
                const theme = colorThemes[item.color] || colorThemes.primary;

                return (
                  <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-2">
                    <div
                      onClick={() => item.link && navigate(item.link)}
                      className="stat-card"
                      style={{
                        background: "#ffffff",
                        borderRadius: "16px",
                        padding: "18px 20px",
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        cursor: item.link ? "pointer" : "default",
                        position: "relative",
                        overflow: "hidden",
                        border: "1.5px solid #e2e8f0",
                        boxShadow: "0 4px 14px rgba(30, 87, 153, 0.06)",
                        transition:
                          "transform 0.3s ease, box-shadow 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(-4px) scale(1.02)";
                        e.currentTarget.style.boxShadow = `0 14px 30px ${theme.glow}`;
                        e.currentTarget.style.borderColor = theme.ring;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(0) scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 14px rgba(30, 87, 153, 0.06)";
                        e.currentTarget.style.borderColor = "#e2e8f0";
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          right: "-30px",
                          bottom: "-30px",
                          width: "110px",
                          height: "110px",
                          borderRadius: "50%",
                          background: theme.bg,
                          opacity: 0.06,
                          pointerEvents: "none",
                        }}
                      />
                      {IconComponent && (
                        <div
                          style={{
                            width: "52px",
                            height: "52px",
                            borderRadius: "14px",
                            background: theme.bg,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#ffffff",
                            flexShrink: 0,
                            boxShadow: `0 8px 18px ${theme.glow}`,
                          }}
                        >
                          <IconComponent size={26} />
                        </div>
                      )}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          style={{
                            fontSize: "12.5px",
                            fontWeight: "600",
                            color: "#64748b",
                            lineHeight: "1.3",
                            marginBottom: "4px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={item.title}
                        >
                          {item.title}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "baseline",
                            gap: "8px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "24px",
                              fontWeight: "800",
                              color: "#1e3a5f",
                              letterSpacing: "-0.5px",
                              lineHeight: 1,
                            }}
                          >
                            {item.value}
                          </span>
                          <span
                            style={{
                              fontSize: "10px",
                              fontWeight: "700",
                              padding: "2px 8px",
                              borderRadius: "20px",
                              background: theme.badge,
                              color: theme.badgeText,
                              letterSpacing: "0.3px",
                            }}
                          >
                            {item.link ? "VIEW →" : "TOTAL"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Col>
                );
              })
            ) : (
              <Col xs={12}>
                <div className="text-center text-muted mt-5">
                  No dashboard data available.
                </div>
              </Col>
            )}
          </Row>

          {/* 🎯 PREMIUM PROGRESS OVERVIEW + REVENUE TREND */}
          <Row className="g-3 mt-3">
            {/* 📊 PREMIUM PROGRESS OVERVIEW */}
            <Col xs={12} lg={7}>
              <div
                style={{
                  background: "#ffffff",
                  borderRadius: "20px",
                  padding: "26px 28px",
                  border: "1.5px solid #eef2f7",
                  boxShadow: "0 10px 30px rgba(30, 87, 153, 0.06)",
                  height: "100%",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {/* Decorative glow */}
                <div
                  style={{
                    position: "absolute",
                    top: "-60px",
                    right: "-60px",
                    width: "180px",
                    height: "180px",
                    borderRadius: "50%",
                    background:
                      "radial-gradient(circle, rgba(43,108,176,0.08) 0%, transparent 70%)",
                  }}
                />

                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "24px",
                    position: "relative",
                  }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center", gap: "12px" }}
                  >
                    <div
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        background:
                          "linear-gradient(135deg, #1e5799, #2b6cb0)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        fontSize: "18px",
                        boxShadow: "0 6px 14px rgba(30, 87, 153, 0.3)",
                      }}
                    >
                      📊
                    </div>
                    <div>
                      <h6
                        style={{
                          margin: 0,
                          fontSize: "15px",
                          fontWeight: "800",
                          color: "#1e3a5f",
                          letterSpacing: "-0.3px",
                        }}
                      >
                        Progress Overview
                      </h6>
                      <p
                        style={{
                          margin: "2px 0 0",
                          fontSize: "11.5px",
                          color: "#94a3b8",
                          fontWeight: "500",
                        }}
                      >
                        Live data snapshot
                      </p>
                    </div>
                  </div>

                  <button
                    onClick={() => navigate("/all-associate-list")}
                    style={{
                      background: "#f1f5f9",
                      border: "none",
                      color: "#2b6cb0",
                      fontSize: "11.5px",
                      fontWeight: "700",
                      cursor: "pointer",
                      padding: "7px 14px",
                      borderRadius: "20px",
                      transition: "all 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#e0ecff";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "#f1f5f9";
                    }}
                  >
                    View All →
                  </button>
                </div>

                {/* Progress Rows */}
                {progressItems.map((item, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "36px 1fr 60px",
                      alignItems: "center",
                      gap: "14px",
                      marginBottom: "18px",
                    }}
                  >
                    {/* Icon bubble */}
                    <div
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "10px",
                        background: item.badge,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "16px",
                      }}
                    >
                      {item.emoji}
                    </div>

                    {/* Label + Bar */}
                    <div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "6px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "12.5px",
                            fontWeight: "700",
                            color: "#334155",
                          }}
                        >
                          {item.label}
                        </span>
                      </div>
                      <div
                        style={{
                          height: "9px",
                          background: "#f1f5f9",
                          borderRadius: "10px",
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            height: "100%",
                            width: `${Math.max(
                              (item.value / maxProgress) * 100,
                              item.value > 0 ? 8 : 0,
                            )}%`,
                            background: item.color,
                            borderRadius: "10px",
                            boxShadow: `0 0 10px ${item.glow}`,
                            transition:
                              "width 1.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            animation: `growBar 1.2s ease ${idx * 0.1}s both`,
                          }}
                        />
                      </div>
                    </div>

                    {/* Count pill */}
                    <div
                      style={{
                        minWidth: "50px",
                        padding: "6px 10px",
                        borderRadius: "10px",
                        background: item.badge,
                        color: item.badgeText,
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "800",
                        border: `1.5px solid ${item.badgeText}20`,
                      }}
                    >
                      {item.value}
                    </div>
                  </div>
                ))}
              </div>
            </Col>

            {/* 💰 DATA TREND (Blue Card) */}
            <Col xs={12} lg={5}>
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #1e5799 0%, #2b6cb0 100%)",
                  borderRadius: "16px",
                  padding: "22px 24px",
                  color: "#ffffff",
                  boxShadow: "0 8px 24px rgba(30, 87, 153, 0.35)",
                  height: "100%",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-50px",
                    right: "-50px",
                    width: "200px",
                    height: "200px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.06)",
                  }}
                />
                <div style={{ position: "relative" }}>
                  <h6
                    style={{
                      margin: 0,
                      fontSize: "15px",
                      fontWeight: "700",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    📈 Data Trend
                  </h6>
                  <p
                    style={{
                      margin: "4px 0 20px",
                      fontSize: "12px",
                      opacity: 0.8,
                      fontWeight: "500",
                    }}
                  >
                    Live overview
                  </p>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "space-between",
                      height: "150px",
                      gap: "8px",
                    }}
                  >
                    {revenueBars.map((bar, idx) => {
                      const height = (bar.value / maxRevenue) * 100;
                      return (
                        <div
                          key={idx}
                          style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            height: "100%",
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                              maxWidth: "42px",
                              height: `${Math.max(height, 8)}%`,
                              background:
                                "linear-gradient(180deg, #ffffff 0%, rgba(255,255,255,0.55) 100%)",
                              borderRadius: "8px 8px 4px 4px",
                              boxShadow:
                                "0 4px 12px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.4)",
                              transition: "all 0.6s ease",
                              animation: `growBar 0.8s ease ${idx * 0.08}s both`,
                            }}
                          />
                          <span
                            style={{
                              marginTop: "8px",
                              fontSize: "10px",
                              opacity: 0.85,
                              fontWeight: "600",
                              letterSpacing: "0.3px",
                            }}
                          >
                            {bar.label}
                          </span>
                          <span
                            style={{
                              fontSize: "11px",
                              fontWeight: "800",
                            }}
                          >
                            {bar.value}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* 🎯 RECENT ACTIVITY + DISTRIBUTION */}
          <Row className="g-3 mt-3">
            {/* 🔔 Recent Activity */}
            <Col xs={12} lg={7}>
              <div
                style={{
                  background: "#ffffff",
                  borderRadius: "16px",
                  padding: "22px 24px",
                  border: "1.5px solid #e2e8f0",
                  boxShadow: "0 4px 14px rgba(30, 87, 153, 0.06)",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <h6
                    style={{
                      margin: 0,
                      fontSize: "15px",
                      fontWeight: "700",
                      color: "#1e3a5f",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    🔔 Recent Activity
                  </h6>
                  <button
                    onClick={() => navigate("/notification-list")}
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#2b6cb0",
                      fontSize: "12.5px",
                      fontWeight: "700",
                      cursor: "pointer",
                    }}
                  >
                    View All →
                  </button>
                </div>

                {recentActivities.map((act, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "14px",
                      padding: "12px 14px",
                      borderRadius: "12px",
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      marginBottom: "10px",
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateX(4px)";
                      e.currentTarget.style.background = "#f1f5f9";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateX(0)";
                      e.currentTarget.style.background = "#f8fafc";
                    }}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "10px",
                        background: act.color,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                        flexShrink: 0,
                      }}
                    >
                      {act.icon}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "#1e3a5f",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {act.text}
                      </div>
                    </div>
                    <span
                      style={{
                        fontSize: "10.5px",
                        fontWeight: "700",
                        padding: "4px 10px",
                        borderRadius: "20px",
                        background: act.color,
                        color: "#1e3a5f",
                        letterSpacing: "0.3px",
                      }}
                    >
                      {act.badge}
                    </span>
                  </div>
                ))}
              </div>
            </Col>

            {/* 🍩 Distribution Donut */}
            <Col xs={12} lg={5}>
              <div
                style={{
                  background: "#ffffff",
                  borderRadius: "16px",
                  padding: "22px 24px",
                  border: "1.5px solid #e2e8f0",
                  boxShadow: "0 4px 14px rgba(30, 87, 153, 0.06)",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h6
                  style={{
                    margin: "0 0 20px",
                    fontSize: "15px",
                    fontWeight: "700",
                    color: "#1e3a5f",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  🍩 Distribution
                </h6>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flex: 1,
                    position: "relative",
                  }}
                >
                  <DonutChart
                    segments={donutSegments}
                    size={180}
                    thickness={28}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      textAlign: "center",
                      pointerEvents: "none",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "22px",
                        fontWeight: "800",
                        color: "#1e3a5f",
                        lineHeight: 1,
                      }}
                    >
                      {donutTotal}
                    </div>
                    <div
                      style={{
                        fontSize: "10px",
                        fontWeight: "600",
                        color: "#64748b",
                        letterSpacing: "0.5px",
                        marginTop: "2px",
                      }}
                    >
                      TOTAL
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    marginTop: "16px",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  {donutSegments.map((seg, idx) => {
                    const pct = ((seg.value / donutTotal) * 100).toFixed(0);
                    return (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          fontSize: "11.5px",
                          fontWeight: "600",
                          color: "#64748b",
                        }}
                      >
                        <span
                          style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            background: seg.color,
                          }}
                        />
                        <span style={{ color: seg.color, fontWeight: "800" }}>
                          {pct}%
                        </span>
                        <span>{seg.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </Col>
          </Row>

          {/* Footer */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "30px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      {/* Custom Message Modal */}
      {showMessageModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className={`modal-content ${
                messageModalContent.type === "success" ? "border-success" : ""
              }`}
            >
              <div className="modal-header d-flex justify-content-between align-items-center">
                <h5
                  className={`modal-title ${
                    messageModalContent.type === "success"
                      ? "text-success"
                      : messageModalContent.type === "error"
                        ? "text-danger"
                        : "text-warning"
                  }`}
                >
                  {messageModalContent.title}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeCustomMessageModal}
                ></button>
              </div>
              <div className="modal-body text-secondary">
                <p>{messageModalContent.text}</p>
              </div>
              <div className="modal-footer justify-content-center">
                {messageModalContent.confirmAction ? (
                  <>
                    <Button
                      variant="secondary"
                      onClick={closeCustomMessageModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant={
                        messageModalContent.type === "warning"
                          ? "warning"
                          : "primary"
                      }
                      onClick={() => {
                        messageModalContent.confirmAction();
                        closeCustomMessageModal();
                      }}
                    >
                      Confirm
                    </Button>
                  </>
                ) : (
                  <Button
                    variant={
                      messageModalContent.type === "success"
                        ? "success"
                        : messageModalContent.type === "error"
                          ? "danger"
                          : "primary"
                    }
                    onClick={closeCustomMessageModal}
                  >
                    OK
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes growBar {
          from { width: 0%; }
        }
        @keyframes growBarHeight {
          from { height: 0%; opacity: 0; }
        }
      `}</style>
    </>
  );
};

export default Dashboard;